import "./bootstrap"; // important: first import

import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./styles/index.css";
import * as Sentry from "@sentry/react";
import AppEntryErrorFallback from "./components/ErrorBoundary/AppEntryErrorFallback";
import { annotateAppEntryError, loadAppEntry } from "./utils/loadAppEntry";

const lazyEntry = (importEntry, entry) => lazy(() => loadAppEntry(importEntry, {
  entry,
  onAutomaticReload: (error, context) => Sentry.captureException(error, {
    level: "warning",
    tags: { area: "app_entry", app_entry: entry },
    contexts: { module_load: context },
  }),
}));

const Entry = /^\/survey(?:\/|$)/.test(window.location.pathname)
  ? lazyEntry(() => import("./pages/surveys/shared/SharedSurveyPublicApp"), "shared-survey")
  : /^\/s\/[^/]+(?:\/present)?\/?$/.test(window.location.pathname)
  ? lazyEntry(() => import("./pages/surveys/live/LivePublicApp"), "live-survey")
  : lazyEntry(() => import("./AuthenticatedAppEntry"), "authenticated");

const root = createRoot(document.getElementById("root"));
root.render(
  <Sentry.ErrorBoundary
    beforeCapture={annotateAppEntryError}
    fallback={({ error }) => <AppEntryErrorFallback error={error} />}
  >
    <StrictMode>
      <Suspense
        fallback={
          <div role="status" style={{ padding: "2rem", fontFamily: "sans-serif" }}>
            Loading Maps &amp; Pathways…
          </div>
        }
      >
        <Entry />
      </Suspense>
    </StrictMode>
  </Sentry.ErrorBoundary>
);
